module.exports = __webpack_public_path__ + "media/images/footer/railslove-210d9c53945b101fe0df53a4888895c7.png";